<!--
 * @Date: 2023-11-15 14:03:14
 * @email: 1098856043@qq.com
 * @LastEditors: j-wei
 * @LastEditTime: 2024-03-12 15:45:54
-->
<template>
  <el-dialog
    :model-value="props.show"
    :title="isWeChat ? '' : title"
    top="0"
    append-to-body
    width="100%"
    fullscreen
    :show-close="isWeChat ? false : true"
    @close="close"
  >
    <template #header>
      <div class="title-box" v-if="isWeChat">
        <div class="title-left">
          <div class="back" @click="close">
          <img :src="require('@/assets/arrowLeft.svg')" alt="" />
        </div>
        <div class="title">
          <span>{{ title }}</span>
        </div>
        </div>
        <div class="title-right">
          <div class="copy" @click=copy(url)>
            <span>Copy</span>
          </div>
          <div class="down" @click="downloadImage(imgUrl)">
            <span>Download</span>
          </div>
        </div>
      </div>
    </template>
    <div class="img_box">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
        "
      >
        <video
          preload="metadata"
          v-if="isVideo(imgUrl)"
          :src="imgUrl"
          controls
        ></video>
        <img v-else :src="imgUrl" alt="Image" />
      </div>
      <div class="share" v-show="!isWeChat">
        <div v-for="(item, index) in extend" :key="index">
          <img :src="item.icon" alt="" @click="item.fn" />
          <div class="type">{{ item.type }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script setup>
import { ElDialog, ElMessage } from "element-plus";
import { defineProps, ref, watch, computed, defineEmits } from "vue";
import "video.js/dist/video-js.css";

const url = computed(() => window.location.href);
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const props = defineProps(["show", "url"]);
const emit = defineEmits(["update:show"]);
const Parse = require("parse");
Parse.initialize("4b61ad984a1", "ec8fbdb80b9ca");
Parse.serverURL = "https://hifoto.gbtops.com/api";
const SHAREFILE = Parse.Object.extend("SHAREFILE");
const query = new Parse.Query(SHAREFILE);
const playerOptions = ref({
  controls: true,
  sources: [
    {
      type: "video/mp4",
      src: "",
    },
  ],
});
// url
watch(
  function () {
    return props.url;
  },
  () => {
    imgUrl.value = "";
    getImage();
  }
);

//判断是否为微信端
const isWeChat = computed(() => {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/.test(ua) ? true : false;
  // const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // const mobileRegex =
  //   /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone/i;
  // return mobileRegex.test(userAgent);
});

const imgUrl = ref("");
const title = ref("");
async function getImage() {
  urlParams;
  query.equalTo("md5", props.url || urlParams.get("md5"));
  // query.equalTo("md5", props.url || "b4c32d3bac93a10c06c5a175e8766ab2");
  const results = await query.find();
  imgUrl.value = results[0]?.attributes.file._url || "";
  playerOptions.value = {
    controls: true,
    sources: [
      {
        type: "video/mp4",
        src: imgUrl.value,
      },
    ],
  };
  title.value = results[0]?.attributes.title || "-";
  await query.find();
}
function isVideo(link) {
  return /\.(mp4|MP4)$/i.test(link);
}
const extend = ref([
  {
    icon: require("@/assets/链接.svg"),
    type: "Copy",
    fn: () => {
      copy(url.value);
    },
  },
  {
    icon: require("@/assets/下载.svg"),
    type: "Download",
    fn: () => {
        downloadImage(imgUrl.value);
    },
  },
]);
function copy(url) {
  const input = document.createElement("input");
  input.value = url;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  ElMessage({
    message: "copy success",
    type: "success",
    size: "mini",
    offset: 60,
  });
}

function downloadImage(url) {
  //判断是否是微信环境
  if (isWeChat.value) {
        alert("In this environment, press and hold the image to download");
        return
    }
  // 创建一个<a>元素
  var link = document.createElement("a");
  // 设置<a>元素的href属性为文件的URL
  link.href = url;
  // 设置<a>元素的download属性为文件名，可以根据需要设置
  link.download = "downloaded_file";

  // 将<a>元素添加到DOM中
  document.body.appendChild(link);

  // 模拟点击<a>元素来触发下载
  link.click();

  // 移除<a>元素，清理DOM
  document.body.removeChild(link);
}

const dialogWidth = ref("66%");
function handleScreenWidthChange() {
  const screenWidth = window.innerWidth;
  // 在这里执行屏幕宽度变化时的逻辑
  if (screenWidth < 768) {
    dialogWidth.value = "100%";
  } else {
    dialogWidth.value = "66%";
  }
}
function close() {
  emit("update:show", false);
}
handleScreenWidthChange();
window.addEventListener("resize", handleScreenWidthChange);
</script>
<style scoped>
img,
video {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.share {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: transparent;
}
.share div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.share img {
  margin: 0;
  width: 50px;
  cursor: pointer;
  opacity: 0.8;
}
.share .type {
  font-size: 16px;
  color: black;
  margin-top: 10px;
}
.img_box {
  height: calc(100vh - 170px);
  margin-top: 20px;
}

.title-box,.title-left,.title-right{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
  }
  .back {
    width: 14px;
    height: 14px;
  }  
  .title{
    margin-left: 20px;
  }
  .copy{
    padding: 5px 8px;
    border: 1px solid #3472c7;
    border-radius: 20px;
    color: #3472c7;
  }
  .down{
    margin-left: 20px;
    padding: 5px 8px;    
    border-radius: 20px;
    background-color: #3472c7;
    color: #fff;
  }
/* 移动端 */
@media (max-width: 768px) {
  .share img {
    margin: 0;
    width: 50px;
    cursor: pointer;
  }
  .share {
    position: absolute;
    right: 20px;
    bottom: 0;
    width: 100px;
  }
  .share .type {
    font-weight: 700;
    font-size: 12px;
    margin-top: 0px;
    color: rgba(0, 0, 0, 0.8);
  }
  .back {
    width: 14px;
    height: 14px;
  }  
  .title{
    margin-left: 20px;
    font-size: 16px;
  }
  .copy{
    padding: 5px 8px;
    border: 1px solid #3472c7;
    border-radius: 20px;
    color: #3472c7;
    font-size: 16px;
  }
  .down{
    margin-left: 20px;
    padding: 5px 8px;    
    border-radius: 20px;
    background-color: #3472c7;
    color: #fff;
    font-size: 16px;    
  }
}
</style>
<style></style>
